import MapPlaceholder from './MapPlaceholder';

export default MapPlaceholder;
